import React from 'react';
import { Icon } from './Icon.js';
export const IconPaperPlane2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 3L10 14", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M21 3L15 22H14.5L10 14L2 9.5L2.00004 9L21 3Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPaperPlane2.js.map